<template>
    <!-- <v-dialog fullscreen style="position: relative; z-index: 999999999"> -->
        <v-card id="pass" style="width: 100vw !important; min-height: 100vh !important" flat color="white">

			<!--
			Printable Access Pass
			  Renders a printable poster containing site Access information
			-->
			<div class="d-flex flex-column align-center justify-center">
                <v-card height=100% style="width: 100% !important" flat color="grey lighten-1" rounded=0 class=" align-center">
				    <!--Company logo-->
				    <v-img v-if="$vuetify.breakpoint.mdAndUp" :src="require('@/assets/tfw_logo_light.png')" contain width="100%" max-height="108" class="mt-6 mb-6 mx-auto"/>
				    <v-img v-else-if="$vuetify.breakpoint.smAndDown" :src="require('@/assets/tfw_logo_light.png')" contain width="100%" max-height="68" class="mt-6 mb-6 mx-auto"/>
                </v-card>

				<!--Instruction-->
				<p class="text-h3 primary--text text-center font-weight-bold pt-4" style="width: 100%">Site Access Permission</p>
                <v-row style="width: 100% !important" class="justify-center pa-0">
                    <v-col cols="12" class="pl-2">
				        <div class="text-h7 text-center font-weight-bold pa-0 ma-0">THIS SITE ACCESS PERMIT DOES NOT AUTHORISE YOU TO START WORK - THIS AUTHORITY WILL BE GIVEN BY THE PERSON IN CHARGE OF THE PREMISES</div>
                    </v-col>
                </v-row>

                
                <v-row style="width: 100vw !important" class="mr-0">
                    <v-col cols="12" class="mr-0 pa-0">
                        <v-card style="width: 100vw !important" flat color="primary" rounded=0  class="">
                            <v-row class="mr-0">
                                <v-col cols="1" class="noprint mr-0"/>
                                <v-col cols="11" class="mr-0">
                                    <p class="text-h7 text-start white--text font-weight-bold pl-2 ma-0">You MUST NOT: work on or near live electrical equipment, work in confined spaces, work at height or work involving fire hazards, such as wielding operations.</p>
                                    <p class="text-h7 text-start white--text font-weight-bold pl-2 ma-0">It should be noted that in law, there is a mandatory requirement for Permit to Work systems for certain types of activity of a high-risk nature, as listed above.</p>
                                    <p class="text-h7 text-start white--text font-weight-bold pl-2 ma-0">Please refer to TfWRL Permit to Work System</p>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row style="width: 100vw !important" class="mr-0">
                    <v-col cols="12" class="mr-0 pa-0">
                        <v-card style="width: 100vw !important" flat rounded=0  class="">
                            <v-row class="mr-0">
                                <v-col cols="1" class="noprint mr-0"/>
                                <v-col cols="11" class="pl-5 pr-0">
                                    <p class="text-h7 text-start font-weight-bold ma-0">Verbal Communications are <span class="primary--text">prohibited</span> and will not be entered into. Occupations will be requested via the Operations Team Leader at Canton or the Team Leader at Holyhead or Machynlleth Depot.</p>
                                    <p class="text-h7 text-start font-weight-bold ma-0">Contract and warrant work on deport rail vehicles will ensure units are berthed as laid down in the VMI for the task being carried out. A safe system of work must at all times be set up in accordance with the policy requirements.</p>
                                
                                
                                    <!--Site name-->
                                    <p class="text-h7 my-1 mt-4 ma-0 text-start font-weight-bold">SITE: <span class="text-h7 darkgrey--text">{{ form.site.siteName }}</span></p>
                                    <p class="text-h7 mb-1 ma-0 text-start font-weight-bold" v-if="form.project.hasOwnProperty('projectName')">PROJECT: <span class="text-h7 darkgrey--text">{{ form.project.projectName }}</span></p>
                                    <p class="text-h7 mb-1 text-start font-weight-bold">WORK TO BE DONE: <span class="text-h7 darkgrey--text">{{ form.accessName }}</span></p>

                                    <!--Site Validity-->
                                    <p class="text-h7 font-weight-bold mb-1 success--text">VALID FROM: <span class=" font-weight-regular darkgrey--text">{{ formattedStartDate }} </span>
                                    <span class="text-h7 pl-2 font-weight-bold mt-0 error--text">VALID TO: <span class=" font-weight-regular darkgrey--text">{{ formattedEndDate }}</span></span></p>

                                    <div v-if="JSON.stringify(form.users) !== '[]'" class="font-weight-bold text-start text-h6 pt-4">PERSONS LISTED FOR SITE ACCESS PERMISSION</div>
                                    <div v-if="JSON.stringify(form.users) !== '[]'" style="width: 100%" class="px-3">
                                        <div v-for="user in form.users" :key="user">
                                            <v-row class="d-flex justify-start">
                                                <!-- <v-col cols="1" class="px-0 mx-0"> -->
                                                    <div class="grey--text font-weight-bold text--darken-2 pr-2">{{ getUserDetails(user, 'userName') }} 
                                                <!-- </v-col>
                                                <v-col cols="1" class="px-0 mx-0"> -->
                                                    <span class="body-1 grey--text text-darken-1"> {{ form.organisation.organisationName }} </span>
                                                <!-- </v-col>
                                                <v-col cols="1" class="px-0 mx-0"> -->
                                                    <span class="body-1 grey--text text-capitalize text-darken-1">  {{ getUserDetails(user, 'userType') }} </span></div>
                                                <!-- </v-col> -->
                                            </v-row>
                                        </div>
                                    </div>

                                    <p class="text-h7 my-1 mt-4 ma-0 text-start font-weight-bold">ISSUING MANAGER NAME: <span class="text-h7 darkgrey--text">{{ form.issuingManager }}</span></p>
                                    <p class="text-h7 my-1 mt-4 ma-0 text-start font-weight-bold">ISSUING MANAGER SIGNATURE: <span class="text-h7 darkgrey--text">________________________________</span></p>
                                    <p class="text-h7 my-1 mt-4 ma-0 text-start font-weight-bold">NAME OF MANAGER AUTHORISING WORK TO COMMENCE: <span class="text-h7 darkgrey--text">{{ form.authorisingManager }}</span></p>
                                    <p class="text-h7 my-1 mt-4 ma-0 text-start font-weight-bold">LOCAL MANAGER: <span class="text-h7 darkgrey--text">{{ form.localManager }}</span></p>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                

				<!--Vindico branding-->
                <div class="justify-center">
                    <div class="px-2"> 
                        <v-img :src="require('@/assets/vlogo.png')" width="128"/>
                    </div>
                    <p class="mt-1 grey--text px-2">Created by Vindico</p>
                </div>
                <div class="d-flex justify-end">
                    <v-card-actions v-if="$vuetify.breakpoint.mdAndUp" class="text-right noprint">
                        <v-spacer/>
                        <v-btn color="grey lighten-1" @click="closeAccess()">Close</v-btn>
                        <v-btn color="black white--text" @click="exportAccess()">Print / Save</v-btn>
                    </v-card-actions>
                    <v-card-actions v-else-if="$vuetify.breakpoint.smAndDown" class="text-right justify-center noprint">
                        <v-btn color="grey lighten-1" @click="closeAccess()">Close</v-btn>
                        <v-btn color="black white--text" @click="exportAccess()">Print / Save</v-btn>
                    </v-card-actions>
                </div>
                
			</div>

        </v-card>
</template>


<script>
import {  mapGetters, mapActions  } from 'vuex'; // Map the Getters from the Vuex Store

export default {
    name: 'AccessGenerator',
    data: () => ({
        form: {},
		formattedStartDate: "", // holds the formated version of the Project Start Date
		formattedEndDate: "", // holds the formated version of the Project End Date
		usersFromOrganisation: [],
    }),
    // * COMPUTED
    computed: {
        ...mapGetters({
			GET_openItem: "GET_openAccess", // Get Open pass Data
        }),
		computedUsersfromOrganisations() {
			return this.usersFromOrganisation.map((item) => {
				return {
                    userId: item.userId,
					userName: `${item.userName} (${item.userStatus})`,
				};
			});
		},
    },
    methods: {
		...mapActions({ ACT_openItem: "ACT_openAccess" }),
        // OPEN ITEM (GENERIC)
        openItem: async function() {
            var t = this;
            var openItem = await t.GET_openItem; // Get Open Item Data
            // console.log(" 1= " + JSON.stringify(openItem.data.data.id, null, 2))
            var item = await t.MIX_readDocumentById('access', openItem.data.data.id)
            t.form = item.data; // Update the Form with the Open Item details 
           // console.log(" 2= " + JSON.stringify(t.form, null, 2))     
            t.formattedStartDate = t.MIX_formatDateTime(t.form.startDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
		    t.formattedEndDate = t.MIX_formatDateTime(t.form.endDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
            return;
        },
		// getUserDetails: function(userId) {
		// 	// console.log("getUserDetails Updated " + userId);
		// 	var t = this;
		// 	var user = t.$find(t.usersFromOrganisation, { userId: userId });
		// 	// console.log("user = " + user);
		// 	return user;
		// },
		getUserDetails: function(userId, field) {
			var t = this;
			var user = t.$find(t.usersFromOrganisation, { userId: userId });
            if ((user !== undefined) && (user !== null) && (user !== '')) {
                return user[field];
            } else {
                return '';
            }
		},        
		getUsersFromOrganisation: async function() {
			var t = this;
			//console.log("t.form.organisation = " + JSON.stringify(t.form.organisation, null, 2));
			var usersResult = await t.MIX_usersFromOrganisation(t.form.organisation.organisationId);
			if (usersResult.code === 1) {
				t.usersFromOrganisation = usersResult.data;
			} else {
				// console.log("ERROR OCCURED - " + usersResult.message + "\n" + usersResult.error);
				// do nothing
			}
		},
        closeAccess() {
            this.MIX_puDialog(false, '', '', '')
        },
        exportAccess() {
            window.print();
        },
    },
    async mounted() {
        var t = this;
        await t.openItem()
		t.getUsersFromOrganisation();
    }
}
</script>

<style>
@media print {
  .noprint {
    display: none !important;
    clear: both !important;
  }
  .pass {
    width: 100vh !important;
    height: 100vh !important;
  }
}
</style>